import { Badge } from "@/components/ui/badge";
import { LabelWithHover } from "@/components/ui/LabelWithHover";
import { getEvalStatusEntry } from "@mspca-beti/shared";
import { cn } from "@/lib/utils";

interface EvalStatusBadgeProps {
  status: string | null | undefined;
  "data-testid"?: string;
  className?: string;
}

export function EvalStatusBadge({
  status,
  "data-testid": testId,
  className,
}: EvalStatusBadgeProps) {
  if (!status) {
    return (
      <Badge
        variant="outline"
        className={cn("text-muted-foreground border-dashed", className)}
        data-testid={testId}
      >
        No Evaluation
      </Badge>
    );
  }
  const entry = getEvalStatusEntry(status);
  if (!entry) {
    return (
      <Badge className={cn("bg-muted", className)} data-testid={testId}>
        {status}
      </Badge>
    );
  }
  const hoverContent = entry.longLabel !== entry.shortLabel ? entry.longLabel : null;
  return (
    <Badge className={cn(entry.colorClass, className)} data-testid={testId}>
      <LabelWithHover label={entry.shortLabel} hoverContent={hoverContent} showUnderline={false} />
    </Badge>
  );
}
